// DialogueCardSection.tsx
import React from "react";
import "../styles/DialogueCardSection.css";

type Props = {
    index: number;
};

const dialogueCards = [
    { title: "Cloud Native", text: "Scalable, Resilient, Serverless", highlight: "Serverless" },
    { title: "Future-Ready Infra", text: "Empowering your applications with future-proof infrastructure ", highlight: "future-proof" },
    { title: "Fast CI/CD", text: "From commit to production — in minutes, not days ", highlight: "Minutes" },
    { title: "DevOps Flow", text: "Seamless CI/CD workflows for faster innovation ", highlight: " CI/CD workflows" },
    { title: "Secure by Design", text: "Built-in Security, Auditable Processes ", highlight: "Security" },
    { title: "Global Compliance", text: "Stay compliant with global standards from day one ", highlight: "compliant" },
    { title: "Full Visibility", text: "Monitor Everything, Miss Nothing ", highlight: "Monitor" },
    { title: "Real-Time Ops", text: "Real-time Insights for proactive DevOps teams ", highlight: "Real-time" }
];

const DialogueCardSection: React.FC<Props> = ({ index }) => {
    const card = dialogueCards[index];

    return (
        <div className="dialogue-section">
                <div className="dialogue-card">
                    <div className="card-header">
                        <span className="card-title card-title-d">{card.title}</span>
                        <span className="menu-dot">⋮</span>
                    </div>
                    <div className="card-body">
                        <h3 className="card-highlight">
                            {card.text.replace(card.highlight, "")}
                            <span className="highlight">{card.highlight}</span>
                        </h3>
                    </div>
                </div>
        </div>
    );
};

export default DialogueCardSection;
